import { ProductType } from "@grandvisionhq/frk-routing";
import { getLocalizedString } from "@grandvisionhq/utils";
import { shouldShowBackInStockNotification } from "./should-show-back-in-stock-notification.js";
const mapShoppingListToWishlistItems = (locale, shoppingList, thresholds) => {
  if (shoppingList) {
    return shoppingList.items.map((item) => {
      const showBackInStockNotification = shouldShowBackInStockNotification(
        item.variant,
        thresholds
      );
      const shoppinglistItem = {
        sku: item.sku,
        name: item.name,
        slug: item.product.slug,
        brand: item.product.brand,
        // According to schema media.images is not nullable, but it sometimes is in the response.
        // OpCos likely have not added an image for each product. Added ? as a workaround.
        imageSrc: item.variant.media.images[0]?.url,
        originalPrice: item.variant.prices.originalPrice?.amount,
        discountedPrice: item.variant.prices.discountedPrice?.price?.amount,
        discountValue: item.variant.prices.discountedPrice?.discountInformation?.value ?? void 0,
        currencyCode: item.variant.prices.originalPrice?.currencyCode,
        showBackInStockNotification,
        isAllowBackOrder: item.variant.isAllowBackOrder,
        stockCount: item.variant.inventory?.totalQuantity,
        isExcludedFromCheckout: !!item.variant.isExcludedFromCheckout
      };
      if (item.variant.__typename === "SunglassesVariant") {
        const { lensFeatures, nullableFrameFeatures, channelAvailability } = item.variant.variantTypeDetails;
        const mappedItem = {
          ...shoppinglistItem,
          productType: ProductType.Sunglasses,
          lensColor: lensFeatures?.lensColor ?? void 0,
          frameColor: nullableFrameFeatures?.color.join(", ") ?? void 0,
          frameSize: nullableFrameFeatures?.size?.size ?? void 0,
          channelAvailability
        };
        return mappedItem;
      }
      if (item.variant.__typename === "FrameVariant" && item.product.__typename === "FrameProduct") {
        const { frameFeatures, channelAvailability } = item.variant.variantTypeDetails;
        const { offerings, isOfferedWithPrescriptions } = item.product.productTypeDetails;
        const isPrescriptionNeeded = (offerings && offerings.some((offering) => offering.isPrescriptionNeeded)) ?? isOfferedWithPrescriptions ?? false;
        const mappedItem = {
          ...shoppinglistItem,
          productType: ProductType.Frames,
          frameColor: frameFeatures.color.join(", ") ?? void 0,
          frameSize: frameFeatures.size?.size ?? void 0,
          channelAvailability,
          isPrescriptionNeeded
        };
        return mappedItem;
      }
      if (item.variant.__typename === "ContactLensVariant" && item.product.__typename === "ContactLensProduct") {
        const { lensType, packageQuantity, channelAvailability } = item.variant.variantTypeDetails;
        const replacementFrequency = getLocalizedString(
          item.product.productTypeDetails.replacementFrequencyAllLocales,
          locale
        );
        const mappedItem = {
          ...shoppinglistItem,
          productType: ProductType.ContactLenses,
          lensType: lensType ?? void 0,
          boxQuantity: packageQuantity,
          replacementFrequency,
          channelAvailability
        };
        return mappedItem;
      }
      if (item.variant.__typename === "ReadyReaderVariant") {
        const { nullableFrameFeatures, channelAvailability } = item.variant.variantTypeDetails;
        const mappedItem = {
          ...shoppinglistItem,
          productType: ProductType.ReadyReaders,
          frameColor: nullableFrameFeatures?.color.join(", ") ?? void 0,
          frameSize: nullableFrameFeatures?.size?.size ?? void 0,
          channelAvailability
        };
        return mappedItem;
      }
      if (item.variant.__typename === "AccessoriesVariant") {
        const { color, channelAvailability } = item.variant.variantTypeDetails;
        const mappedItem = {
          ...shoppinglistItem,
          productType: ProductType.Accessories,
          accessoryColor: color.join(","),
          channelAvailability
        };
        return mappedItem;
      }
      if (item.variant.__typename === "SolutionVariant") {
        const { channelAvailability } = item.variant.variantTypeDetails;
        const mappedItem = {
          ...shoppinglistItem,
          productType: ProductType.Solutions,
          packageOptions: void 0,
          channelAvailability
        };
        return mappedItem;
      }
      return {
        ...shoppinglistItem,
        productType: ProductType.Sunglasses
      };
    });
  }
  return [];
};
export {
  mapShoppingListToWishlistItems
};
//# sourceMappingURL=map-shopping-list-to-wishlist-items.js.map
